import { render, staticRenderFns } from "./AIModelDetail.vue?vue&type=template&id=8a83396e&scoped=true&"
import script from "./AIModelDetail.vue?vue&type=script&lang=js&"
export * from "./AIModelDetail.vue?vue&type=script&lang=js&"
import style0 from "./AIModelDetail.vue?vue&type=style&index=0&id=8a83396e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83396e",
  null
  
)

export default component.exports